import React, { useState, useEffect } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Alert,
  Label,
  Input,
  Badge,
  FormGroup,
} from "reactstrap"
import { post, get } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import Loader from "common/loader"
import Select from "react-select"
import { SEARCH_TIMESLOT_EXCEPTION } from "helpers/api_endpoints"
import { ITEMS_PER_PAGE } from "helpers/pagination_helper"

//meta title
document.title = "Time Slots"

const PartnersBranchTimeSlotList = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const [timeSlots, setTimeSlots] = useState([])
  const [searchTimeSlots, setSearchTimeSlots] = useState([])
  const [filters, setFilters] = useState({})
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [successMsg, setsuccessMsg] = useState("")
  const [errorMsg, seterrorMsg] = useState('')
  const [partnerBranchName, setPartnerBranchName] = useState('')
  const slotStatus = [{value:'1', label:'Active'}, {value:'0', label:'Inactive'}];
	const daysOfWeek = [
		{ value: 0, label: "Sunday" },
		{ value: 1, label: "Monday" },
		{ value: 2, label: "Tuesday" },
		{ value: 3, label: "Wednesday" },
		{ value: 4, label: "Thursday" },
		{ value: 5, label: "Friday" },
		{ value: 6, label: "Saturday" },
	];  

  useEffect(() => {
    if (location.state) {
        if (location.state.successMsg) {
            setsuccessMsg(location.state.successMsg);
            setTimeout(() => {
                setsuccessMsg("");
                navigate(location.pathname, { replace: true, state: {} });
            }, 4000);
        }
        if (location.state.errorMsg) {
            seterrorMsg(location.state.errorMsg);
            setTimeout(() => {
                seterrorMsg("");
                navigate(location.pathname, { replace: true, state: {} });
            }, 4000);
        }
    }
    
    fetchTimeSlots()
  }, [page, filters, location.state, navigate, location.pathname])

  const fetchTimeSlots = () => {
    setLoading(true)
    post(SEARCH_TIMESLOT_EXCEPTION)
      .then(response => {
          const data = response.data;
          setTimeSlots(data);
          setSearchTimeSlots(data);
          setTotalPages(data.pagination?.totalPages || 1);
          setPage(data.pagination?.currentPage || 1);
          setLoading(false);
      })
      .catch(error => {
          if (error?.response?.status == 400) {
              console.log(error)
          }
          setLoading(false)
      })
  }

  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1)
    }
  }

  const getDayName = (dayNumber) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    return days[dayNumber] || dayNumber
  }

  const formatTime = (timeString) => {
    if (!timeString) return ''
    const [hours, minutes] = timeString.split(':')
    const hour = parseInt(hours, 10)
    const ampm = hour >= 12 ? 'PM' : 'AM'
    const hour12 = hour % 12 || 12
    return `${hour12}:${minutes} ${ampm}`
  }

  const handleFilter = (type, val) => {
    const sTimeSlots = [...timeSlots];
    setSearchTimeSlots(timeSlots);
    let res = [];
    if(val == undefined)
      return;
    // console.log('d', type, val, timeSlots.length,searchTimeSlots.length)
      if(type == 'name')
      {
        res = sTimeSlots.filter(el => {
          return el.name.indexOf(val) > -1;
        });
      }
      else if(type == 'slotDateFrom')
      {
        res = sTimeSlots.filter(el => {
          return el.slotDateFrom?.indexOf(val) > -1;
        });
      }
      else if(type == 'slotDateTo')
      {
        res = sTimeSlots.filter(el => {
          return el.slotDateTo?.indexOf(val) > -1;
        });
      }
      else if(type == 'daysOfWeek')
      {
        res = sTimeSlots.filter(el => {
          return el.daysOfWeek?.indexOf(parseInt(val)) > -1;
        });
      }
      else if(type == 'slotStatus')
      {
        res = sTimeSlots.filter(el => {
          return el.status == val;
        });
      }
      setSearchTimeSlots(res);
  }

  const handleDaysOfWeek = (days) => {
	const dayOptions = [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday",
	];
    let dayNames = '';
    days.some(day => {
      dayNames += dayOptions[day]+' '
    })
    return dayNames;
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs 
            title="Home" 
            breadcrumbItem="Time Slot Exceptions"
          />
          <Row>
            <Col xl={12}>
              <Card>
                <br></br>
                {successMsg ? (
                  <Alert style={{ margin: "25px" }} color="success">
                    {successMsg}
                  </Alert>
                ) : null}
                <CardTitle>
                  <Link to={`/timeslots/exceptions/add`}>
                    <button
                      style={{ float: "right", marginRight: "20px" }}
                      className="btn btn-sm btn-primary"
                    >
                      <i className="dripicons-plus"></i> &nbsp;
                      <Trans>Create Time Slot</Trans>
                    </button>
                  </Link>
                </CardTitle>
                                <div style={{ margin: "25px" }}>
                                    <div className="row">
                                        <div className="form-group col-md-2 mt-2">
                                            <Label className="form-label"><Trans>Name</Trans></Label>
                                            <Input
                                                name="name"
                                                className="form-control"
                                                placeholder=""
                                                type="text"
                                                onChange={(e) => handleFilter('name', e.target.value)}
                                                onKeyDown={(e) => handleFilter('name', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-2 mt-2">
                                            <Label className="form-label"><Trans>Date from</Trans></Label>
                                            <Input
                                                name="slotDateFrom"
                                                className="form-control"
                                                placeholder=""
                                                type="date"
                                                onChange={(e) => handleFilter('slotDateFrom', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-2 mt-2">
                                            <Label className="form-label"><Trans>Date To</Trans></Label>
                                            <Input
                                                name="slotDateTo"
                                                className="form-control"
                                                placeholder=""
                                                type="date"
                                                onChange={(e) => handleFilter('slotDateTo', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-2 mt-2">
                                            <Label className="form-label"><Trans>Recurring days</Trans></Label>
                                            <Select
                                                name="daysOfWeek"
                                                options={daysOfWeek} 
                                                className="form-control select2"
                                                isClearable={true}
                                                onChange={(e) => handleFilter('daysOfWeek',e?.value)}
                                            />
                                        </div>
                                        <div className="form-group col-md-2 mt-2">
                                            <Label className="form-label"><Trans>Status</Trans></Label>
                                            <Select
                                                            name="orderStatusId"
                                                            options={slotStatus} 
                                                            className="form-control select2"
                                                            onChange={(e) => handleFilter('slotStatus',e.value)}
                                                        />
                                        </div>
                                    </div>
                                </div>
                <CardBody>
                {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                  <div className="table-responsive">
                    <Table className="table table-striped table-bordered mb-0">
                      <thead>
                        <tr>
                          <th>
                            <Trans>ID</Trans>
                          </th>
                          <th>
                            <Trans>Time Slot Name</Trans>
                          </th>
                          <th>
                            <Trans>Date from</Trans>
                          </th>
                          <th>
                            <Trans>Date To</Trans>
                          </th>
                          <th>
                            <Trans>Status</Trans>
                          </th>
                          <th>#</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <th colSpan={9} className="text-center">
                              <Loader></Loader>
                            </th>
                          </tr>
                        ) : null}
                        {searchTimeSlots?.length === 0 && !loading ? (
                          <tr>
                            <td colSpan={9} className="text-center">
                              <Trans>No time slots found</Trans>
                            </td>
                          </tr>
                        ) : null}
                        {searchTimeSlots?.map((timeSlot, index) => (
                          <tr key={index}>
                            <td>{timeSlot.id}</td>
                            <td>{timeSlot.name}</td>
                            <td>
                              {timeSlot.slotDateFrom?.split('T')[0]}
                            </td>
                            <td>
                              {timeSlot.slotDateTo?.split('T')[0]}
                            </td>
                            <td>{handleDaysOfWeek(timeSlot.daysOfWeek)}</td>
                            <td>
                              <Badge
                                className={
                                  timeSlot.status == 2
                                    ? "bg-danger"
                                    : "bg-success"
                                }
                              >
                                <Trans>
                                  {timeSlot.status == 2
                                    ? "inactive"
                                    : "active"}
                                </Trans>
                              </Badge>
                            </td>
                            <td>
                              <Link to={`/timeslots/exceptions/edit/${timeSlot.id}`}>
                                <button className="btn btn-sm btn-info">
                                  <i className="dripicons-pencil"></i> &nbsp;
                                  <Trans>Duplicate</Trans>
                                </button>
                              </Link>{" "}
                              &nbsp;
                              {/* <Link to={`/timeslots/exceptions/remove/${timeSlot.id}`}>
                                <button className="btn btn-sm btn-danger">
                                  <i className="dripicons-trash"></i> &nbsp;
                                  <Trans>Remove</Trans>{" "}
                                </button>
                              </Link> */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <br></br>
                  {totalPages > 1 && (
                    <div className="text-center">
                      <button
                        className="btn btn-sm btn-dark"
                        onClick={handlePrevPage}
                        disabled={page === 1}
                      >
                        <Trans>Previous</Trans>
                      </button>
                      &nbsp;
                      <button
                        className="btn btn-sm btn-dark"
                        onClick={handleNextPage}
                        disabled={page === totalPages}
                      >
                        <Trans>Next</Trans>
                      </button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default PartnersBranchTimeSlotList